<template>
	<div class="inner-page team-management">
    <AppHead title="Distributor Management" />
    <PageHeader 
      title="Distributor Management"
      desc="Manage your distributors, change distributor settings, and create new distributors."
      :hasButton="true"
      buttonLabel="Create new distributor"
      buttonRoute="/admin/team/new"
      :showHelper="true"
      helpTitle="Welcome to Distributor Management"
      helpDesc="Within this page you can see all of the distributors that you have. You can create a new distributor by clicking the 'Create New Team' button in the top right."
      :hr="true"
      />

    <div class="user-teams-overview">
      <div class="teams-column">
        
        <TableTeams
          :teams="teams"
          />

      </div>

    </div>

	</div>
</template>

<script>
import AppHead from "@/Components/AppHead"
import AppLayout from "@/Layouts/AppLayout.vue"
import PageHeader from "@/Components/PageHeader"
import TableTeams from "@/Components/TableTeams"
import Button from '@/Components/Button'

export default {
	components: {
    AppHead,
    PageHeader,
    TableTeams,
    Button
	},
  title: 'Team Management',
  props: {
    noTeamUsers: {
      type: Object,
      default: {}
    },
    teams: {
      type: Object,
      default: {}
    }
  },
  data: () => {
    return {
      
    }
  },
	
	layout: AppLayout,
  methods: {
    
  }
};
</script>

<style lang="sass">

// .team-management

</style>